import { CSSProperties } from 'react';

export const menuTopPadding = 4;
export const menuBottomPadding = 4;

export function getListStyle(width?: number): CSSProperties {
    return {
        listStyleType: 'none',
        margin: '0px',
        padding: `${menuTopPadding}px 0px ${menuBottomPadding}px 0px`,
        width: width,
    };
}
